/* eslint-disable quote-props */
export default {

  // COMMOM
  'yes': 'Yes',
  'no': 'No',
  'tip': 'Tip',
  'there-are': 'There are',
  'there-is': 'There is',
  'read-more': 'Read more',
  'company': 'Company',
  'disabled': 'Disabled',
  'soon': 'Soon',
  'in': 'In',
  'by': 'by',
  'of': 'of',
  'min-read': 'min read',
  'no-articles': 'No articles available',
  'no-questions': 'No questions available',
  'no-tracks': 'No tracks available',
  'department': 'Departament',
  'tags': 'Tags',
  'title': 'Title',
  'content': 'Content',
  'update': 'Update',
  'updated': 'Updated',
  'save': 'Save',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'edit': 'Edit',
  'delete': 'Delete',
  'unblock': 'Unblock',
  'block': 'Block',
  'blocked': 'Blocked',
  'users': 'Users',
  'user': 'User',
  'new-article': 'New article',
  'article': 'Article',
  'articles': 'Articles',
  'tracks': 'Tracks',
  'track': 'Track',
  'questions': 'Questions',
  'question': 'Question',
  'departments': 'Departments',
  'profile': 'Profile',
  'logout': 'Logout',
  'create': 'Create',
  'name': 'Name',
  'actions': 'Actions',
  'description': 'Description',
  'follow': 'follow',
  'unfollow': 'unfollow',
  'followers': 'Followers',
  'follower': 'Follower',
  'trending-tags': 'Trending tags',
  'followed-tags': 'Followed tags',
  'results': 'Results',
  'search': 'Search',
  'search-for-articles-and-more': 'Search for articles, users, tracks and questions ',
  'no-articles-found-for-term': 'No articles found for term',
  'no-users-found-for-term': 'No users found for term',
  'no-tracks-found-for-term': 'No tracks found for term',
  'no-questions-found-for-term': 'No questions found for term',
  'search-articles-placeholder': 'i.e. What are soft skills?',
  'password': 'Password',
  'access': 'Access',
  'public': 'Public',
  'department-only': 'Department',
  'private': 'Private',
  'click-here': 'Click here',
  'select-city': 'Select a city',
  'select-state': 'Select a state',
  'select-country': 'Select a country',
  'select-access': 'Select an access',
  'select-department': 'Select a department',
  'select-language': 'Select a language',
  'ratings': 'Ratings',
  'ranking': 'Ranking',

  // INFO / TOOLTIPS
  'some-tracks-may-not-appear-due-to-permission': 'Some tracks may not appear due to its permission.',
  'some-articles-may-not-appear-due-to-permission': 'Some articles may not appear due to its permissions.',
  'some-articles-and-questions-are-not-available-due-to-your-permission': 'Some articles and/or questions are not available due to your permission.',
  'your-company-has-no-departments': 'Your company has no departments.',
  'you-are-not-allowed-to-choose-departments': 'You are not allowed to choose departments.',
  'your-company-only-have-this-department': 'Your company only have this department.',
  'public-article-access-info': 'All company will see this article.',
  'department-article-access-info': 'Only the department will see this article.',
  'private-article-access-info': 'Only you will see this article.',
  'public-track-access-info': 'All company will see this track.',
  'department-track-access-info': 'Only the department will see this track.',
  'public-question-access-info': 'All company will see this question.',
  'department-question-access-info': 'Only the department will see this question.',

  // ERRORS
  'sorry': 'Sorry!',
  'permission-denied': 'Permission denied',
  'you-dont-have-access-to-this-page-or': 'You do not have access to this page or',
  'your-session-has-expired': 'your session has expired.',
  'back-to-login': 'Back to login',
  'article-not-found': 'Article not found',
  'we-could-not-find-the-article-you-are-looking-for': 'We couldn\'t find the article you are looking for.',
  'return-to-page': 'Return to page',
  'you-dont-have-permission-to-access-this-article': 'You don\'t have permission to access this article!',
  'you-dont-have-permission-to-edit-this-article': 'You don\'t have permission to edit this article!',
  'you-dont-have-permission-to-create-an-article': 'You don\'t have permission to create an article!',
  'you-dont-have-the-right-permission': 'You don\'t have the right permission.',
  'the-article-is-personal-or-exclusive-of-a-department-other-than-yours': 'The article is personal or exclusive of a department other than yours.',
  'please-write-a-title-for-your-article': 'Please write a title for your article',
  'your-article-should-have-some-content': 'Your article should have some content.',
  'please-choose-a-department-for-your-article': 'Please choose a department for your article',
  'track-not-found': 'Track not found',
  'you-dont-have-permission-to-edit-this-track': 'You don\'t have permission to edit this track!',
  'you-dont-have-permission-to-edit-this-question': 'You don\'t have permission to edit this question!',
  'you-dont-have-permission-to-access-this-track': 'You don\'t have permission to access this track!',
  'the-track-is-exclusive-of-a-department-other-than-yours': 'The track is exclusive of a department other than yours.',
  'we-could-not-find-the-track-you-are-looking-for': 'We couldn\'t find the track you are looking for.',
  'you-cant-create-a-track': 'You can\'t create a track!',
  'you-cant-create-a-question': 'You can\'t create a question!',
  'you-dont-have-the-right-permission-to-it': 'You don\'t have the right permission to it.',
  'you-dont-have-permission-to-access-this-question': 'You don\'t have permission to access this question!',
  'the-question-was-specifically-directed-to-a-department-other-than-yours': 'The question was specifically directed to a department other than yours.',
  'question-not-found': 'Question not found!',
  'we-could-not-find-the-question-you-are-looking-for': 'We couldn\'t find the question you are looking for.',
  'something-went-wrong': 'Something went wrong...',
  'please-try-to-reload-page-or-contact-support': 'Please try to reload page or contact support.',
  'you-dont-have-permission-to-edit-departments': 'You don\'t have permission to edit departments!',
  'email-already-exist': 'The e-mail has already been registered!',
  'company-name-already-exist': 'The company name has already been registered!',
  'vat-cnpj-already-exist': 'The VAT number has already been registered!',
  'please-select-the-company-state': 'Please select the "State" of the company!',
  'error-fetching-company-data': 'Error fetching company data.',
  'error-updating-company': 'Error on updating company data.',
  'you-cant-create-a-user': 'You can\'t create a user!',
  'you-cant-edit-a-user': 'You can\'t edit this user!',

  // EDITORJS
  'move-up': 'Move up',
  'move-down': 'Move down',
  'text': 'Text',
  'heading': 'Heading',
  'list': 'List',
  'editor-warning': 'Warning',
  'checklist': 'Checklist',
  'quote': 'Quote',
  'code': 'Code',
  'delimiter': 'Delimiter',
  'raw-html': 'Raw HTML',
  'table': 'Table',
  'marker': 'Marker',
  'bold': 'Bold',
  'italic': 'Italic',
  'inline-code': 'Inline code',
  'image': 'Image',
  'convert-to': 'Convert to',
  'add': 'Add',
  'options': 'Options',
  'click-to-tune': 'Click to tune',
  'or-drag-to-move': 'or drag to move',
  'select-an-image': 'Select an Image',
  'unordered': 'Unordered',
  'ordered': 'Ordered',
  'add-a-link': 'Add a link',
  'with-headings': 'With headings',
  'without-headings': 'Without headings',
  'add-column-to-left': 'Add column to left',
  'add-column-to-right': 'Add column to right',
  'delete-column': 'Delete column',
  'add-row-above': 'Add row above',
  'add-row-below': 'Add row below',
  'delete-row': 'Delete row',
  'enter-a-code': 'Enter a code',

  // COMPANY SETTINGS
  'settings-of': 'Settings of',
  'company-settings-info': 'This is the page where you can edit the companie\'s informations.',
  'companys-name': 'Company\'s name',
  'address': 'Address',
  'complement': 'Address Complement',
  'enter-the-company-name-placeholder': 'Enter the company\'s name',
  'enter-the-company-vat-placeholder': 'Enter the company\'s VAT',
  'company-country-placeholder': 'ex.: Canada',
  'company-state-placeholder': 'ex.: Ontario',
  'company-city-placeholder': 'ex.: Toronto',
  'company-zip-code-placeholder': 'ex.: 66777',
  'company-address-placeholder': 'ex.: Street 292',
  'company-address-2-placeholder': 'ex.: Residence, Apartment 202',
  'company-updated': 'Company updated!',

  // LOGIN | REGISTER
  'please-sign-in': 'Please sign in',
  'email-address': 'E-mail address',
  'sign-in': 'Sign in',
  'dont-have-an-account': 'Don\'t have an account?',
  'register': 'Register',
  'welcome-to-dara': 'Welcome to Dara',
  'please-enter-your-information': 'Please enter your information',
  'already-have-an-account': 'Already have an account?',
  'login': 'Login',
  'company-name': 'Company name',
  'street-po-box': 'Street, P.O Box',
  'building-apartment-floor': 'Building, apartment, floor...',
  'vat-identification-number': 'VAT identification number',
  'the-new-password-was-sent-to': 'The new password was send to',
  'check-spam-folder': 'Check spam folder!',
  'please-type-your-email': 'Please, type your e-mail',
  'email-not-found': 'E-mail not found!',
  'verify-valid-email': 'The "e-mail" field must be a valid e-mail!',
  'email-or-password-incorrect': 'E-mail address or password is incorrect! Please try again.',
  'forgot-password': 'Forgot password?',
  'previous-step': 'Previous step',
  'next-step': 'Next step',
  'step-1': 'Step 1',
  'step-2': 'Step 2',
  'user-registration': 'User Registration',
  'company-registration': 'Company Registration',
  'this-user-was-blocked': 'This user has been blocked!',
  'this-user-was-deleted': 'This user has been deleted!',
  'no-active-user-found': 'No active users found with this e-mail.',

  // FIELDS
  'first-name-field': '"first name"',
  'last-name-field': '"last name"',
  'email-field': '"e-mail"',
  'password-field': '"password"',
  'confirm-password-field': '"confirm password"',
  'company-name-field': '"company\'s name"',
  'country-field': '"country"',
  'state-field': '"state"',
  'city-field': '"city"',
  'zip-code-field': '"zip code"',
  'address-field': '"address"',
  'address-complement-field': '"address complement"',
  'vat-field': '"VAT"',
  'department-field': '"department"',
  'position-field': '"position"',
  'description-field': '"description"',
  'track-name-field': '"track\'s name"',
  'title-field': '"title"',
  'content-field': '"content"',
  'department-name-field': '"department\'s name"',
  'phone-field': '"phone"',
  'birthday-field': '"birthday"',
  'language-field': '"language"',
  'biography-field': '"Biography"',
  'access-field': '"access"',

  // MODAL
  'are-you-sure-you-want-to-delete-this-item': 'Are you sure you want to delete this item?',
  'change-your-password': 'Change your password',
  'you-should-choose-a-new-password': 'You should choose a new password.',
  'type-your-new-password': 'Type your new password',
  'confirm-your-new-password': 'Confirm your new password',
  'unable-to-delete-department': 'Unable to delete this department!',
  'user-associated-with-this-department': 'associated with this department.',
  'users-associated-with-this-department': 'associated with this department.',
  'article-associated-with-this-department': 'associated with this department (the article may be private).',
  'articles-associated-with-this-department': 'associated with this department (some articles may be private).',
  'question-associated-with-this-department': 'associated with this department.',
  'questions-associated-with-this-department': 'associated with this department.',
  'track-associated-with-this-department': 'associated with this department.',
  'tracks-associated-with-this-department': 'associated with this department.',
  'are-you-sure-you-want-to-delete-this-department': 'Are you sure you want to delete this department?',
  'are-you-sure-you-want-to-delete-this-track': 'Are you sure you want to delete this track?',
  'are-you-sure-you-want-to-delete-this-user': 'Are you sure you want to remove this user?',
  'are-you-sure-you-want-to-delete-this-article': 'Are you sure you want to remove this article?',
  'are-you-sure-you-want-to-delete-this-question': 'Are you sure you want to remove this question?',
  'are-you-sure-you-want-to-mark-all-notifications-as-readed': 'Are you sure you want to mark all notifications as readed?',

  // NOTIFICATIONS
  'no-notifications-left': 'No notifications left :)',
  'notification-panel': 'Notification panel',
  'created-on': 'Created on',
  'new-article-notification': 'writed a new article!',
  'new-article-from-followed-user': 'writed a new article!',
  'updated-article-notification': 'updated an article!',
  'you-receive-a-new-answer': 'answered you!',
  'new-question-notification': 'created a question!',
  'update-question-notification': 'updated a question!',
  'new-question-from-followed-user': 'created a question!',
  'update-question-from-followed-user': 'updated a question!',
  'new-track-notification': 'created a track!',
  'updated-track-notification': 'updated a track!',
  'followed-track-updated': 'Followed track updated!',
  'mark-all-as-readed': 'Mark all as readed',
  'a-user': 'A user',
  // 'article-tags-description-notification': 'New article with followed tags.',
  // 'updated-article-tags-description-notification': 'Updated article with followed tags.',
  // 'new-article-description-notification': 'Your company has a brand new article. Take a look!',
  // 'updated-article-description-notification': 'Your company has a updated article. Take a look!',
  // 'one-of-your-questions-was-answered': 'Thats awesome! One of your questions was answered.',
  // 'question-tags-description-notification': 'New question with followed tags.',
  // 'update-question-tags-description-notification': 'Updated question with followed tags.',
  // 'a-user-has-a-question-try-to-help': 'A user has a question.',
  // 'a-user-update-a-question-try-to-help': 'A user updated a question.',
  // 'the-user-has-a-question-try-to-help': 'The user has a question.',
  // 'the-user-update-a-question-try-to-help': 'The user has updated a question.',
  // 'new-track-description-notification': 'Your company has a brand new track. Take a look!',
  // 'updated-track-description-notification': 'See what changed!',

  // VIEW TAG
  'tag-articles': 'Tag\'s articles',
  'tag-questions': 'Tag\'s questions',
  'search-tag-placeholder': 'Search for tags (and press enter)',

  // TOASTS
  'important': 'Important!',
  'error': 'Error!',
  'success': 'Success!',
  'warning': 'Warning!',
  'passwords-doesnt-match': 'Passwords doesn\'t match.',
  'you-need-to-choose-a-new-password': 'You need to choose a new password.',
  'password-too-short': 'Your password must be at least 8 characters long.',
  'password-must-have-special-chars-and-numbers': 'Your password must contain numbers and special characters.',
  'error-updating-users-password': 'Error updating user\'s password.',
  'error-on-searching-articles': 'Error on searching articles.',
  'error-on-searching-users': 'Error on searching users.',
  'error-on-searching-tracks': 'Error on searching tracks.',
  'error-on-searching-questions': 'Error on searching questions.',
  'error-on-fetching-department': 'Error on fetching department.',
  'we-could-not-delete-your-question-at-this-moment': 'We couldn\'t delete your question at this moment.',
  'error-getting-users': 'Error getting users.',
  'error-removing-notification': 'Error removing notification',
  'we-could-not-save-your-question-at-this-moment': 'We couldn\'t save your question at this moment.',
  'error-on-fetching-question': 'Error on fetching question.',
  'error-on-fetching-answers': 'Error on fetching answers.',
  'error-on-updating-question': 'Error on updating question.',
  'the-limit-is-one-you-selected': 'The limit is 1, you selected ',
  'totally-please-first-remove-the-unwanted-file': ' totally. Please first remove the unwanted file.',
  'error-deleting-old-image': 'Error deleting old image.',
  'error-uploading-new-image': 'Error uploading new image.',
  'error-on-updating-users-preferences': 'Error on updating user\'s preferences.',
  'error-on-updating-users-profile': 'Error on updating user\'s profile.',
  'error-getting-articles-from-tag': 'Error getting articles from tag.',
  'error-getting-questions-from-tag': 'Error getting questions from tag.',
  'error-getting-tag-user-relation': 'Error getting tag/user relation.',
  'error-getting-tag': 'Error getting tag.',
  'error-following-tag': 'Error following tag.',
  'error-unfollowing-tag': 'Error unfollowing tag.',
  'error-removing-the-question': 'Error removing the question.',
  'error-on-fetching-track': 'Error on fetching track.',
  'error-getting-articles-from-track': 'Error getting articles from track.',
  'error-on-saving-track': 'Error on saving track.',
  'this-article-already-exists-in-the-track': 'This article already exists in the track!',
  'error-getting-the-following-status': 'Error getting the "following" status.',
  'error-getting-track': 'Error getting track.',
  'error-on-following-track': 'Error on following track.',
  'error-on-unfollowing-track': 'Error on unfollowing track.',
  'error-on-following-user': 'Error on following user.',
  'error-on-unfollowing-user': 'Error on unfollowing user.',
  'error-on-getting-user-by-id': 'Error on getting user by ID.',
  'error-updating-users-profile': 'Error updating user\'s profile.',
  'error-creating-new-user': 'Error creating a new user.',
  'error-on-importing-users': 'Error on importing users!',
  'error-on-importing-user-with-no-department': 'Error on importing users! User without department.',
  'error-on-getting-users-articles': 'Error on getting user\'s articles.',
  'error-on-getting-followers': 'Error on getting followers.',
  'users-password-updated': 'User\'s password updated!',
  'question-removed': 'Question removed!',
  'user-successfully-saved': 'User successfully saved!',
  'users-successfully-imported': 'Users successfully imported!',
  'file-with-incorrect-model-data': 'File with incorrect data model!',
  'user-with-missing-information': 'File has user with missing information!',
  'inserted-users': 'Inserted users:',
  'email-already-registered': 'E-mails of already registered users:',
  'some-emails-already-registered': 'Some users have already been registered before!',
  'it-was-not-possible-to-get-related-article': 'It was not possible to get related article.',
  'it-was-not-possible-to-get-next-article': 'It was not possible to get next article.',
  'there-is-a-article-from-another-department-in-the-track': 'There\'s an article from another department in the track.',
  'there-is-a-non-public-article-in-the-track': 'There\'s an non public article in the track.',
  'there-is-a-personal-article-in-the-track': 'There\'s a personal article in the track.',
  'the-article-belong-to-a-track-be-careful-changing-department': 'The article belong to a track. Be careful when changing the department.',
  'the-article-belong-to-a-track-be-careful-changing-access': 'The article belong to a track. Be careful when changing the access.',
  'you-need-to-specify-the-user-department': 'You need to specify the user\'s department.',
  'you-need-to-specify-the-department-of-the-imported-users': 'You need to specify the department of the imported users',
  'you-need-to-select-a-file': 'You need to select a file.',
  'you-need-to-specify-the-track-department': 'You need to specify the track\'s department.',
  'you-need-to-specify-the-question-department': 'You need to specify the question\'s department.',
  'error-verifying-users-associated-with-department': 'Error verifying users associated with the department.',
  'error-verifying-articles-associated-with-department': 'Error verifying articles associated with the department.',
  'error-verifying-tracks-associated-with-department': 'Error verifying tracks associated with the department.',
  'error-verifying-questions-associated-with-department': 'Error verifying questions associated with the department.',
  'error-getting-tracks-department': 'Error getting track\'s department.',
  'error-getting-questions-department': 'Error getting question\'s department.',
  'error-getting-department': 'Error getting department.',
  'error-on-saving-article': 'Error on saving article.',
  'error-on-saving-department': 'Error on saving department.',
  'the-department-description-is-too-long': 'The department\'s description is too long.',
  'cant-add-user-with-permission-three': 'It\'s not possible to add users with permission 3.',
  'error-marking-question-as-answered': 'Error on marking question as answered.',
  'error-getting-best-writer': 'Error getting the best writer.',
  'error-getting-top-writer': 'Error getting the top writer.',
  'error-getting-top-reader': 'Error getting the top reader.',
  'error-start-date-greater-then-end-date': 'The start date must be less than the end date.',

  // VIEW|ADD|EDIT DEPARTMENT
  'departments-name': 'Department\'s name',
  'see-all': 'See all articles',
  'creating-department': 'Creating a department',
  'creating-department-info': 'Choose the name and try to describe the department in a few words.',
  'editing-department': 'Editing department',
  'editing-department-info1': 'This is the page where you can edit a department.',
  'editing-department-info2': 'Change the name of the department and rewrite the description!',
  'department-name-placeholder': 'i.e. Human resources',
  'department-description-placeholder': 'Try to describe the purpose of this department',
  'the-company-already-has-a-department-with-this-name': 'The company already has a department with this name.',
  'to-add-a-new-department': 'to add a new department.',

  // VIEW|ADD QUESTION
  'answer': 'Answer',
  'answers': 'Answers',
  'no-answers': 'No answers',
  'mark-as-answered': 'Mark as answered',
  'total-answers': 'Total answers',
  'new-question': 'New question',
  'editing-question': 'Editing a question',
  'creating-question-info1': 'This is the page where you can create your question.',
  'creating-question-info2': 'Ask questions about anything related to your role, the company, and more.',
  'editing-question-info1': 'This is the page where you can edit your question.',
  'question-title-placeholder': 'i.e. How to...',
  'question-description-placeholder': 'Try to be as descriptive as possible (use "#" to insert tags)',
  'want-to-ask-an-anonymous-question': 'Want to ask an anonymous question?',
  'anonymous-question': 'Anonymous question',

  // VIEW|ADD|EDIT TRACK
  'tracks-name': 'Track\'s name',
  'reading-time': 'Reading time',
  'number-of-articles': 'Number of articles',
  'new-track': 'New track',
  'creating-track-info1': 'This is the page where you can create a track.',
  'creating-track-info2': 'Choose a name for the track, write a description and add articles!',
  'editing-track': 'Editing track',
  'editing-track-info1': 'This is the page where you can edit a track.',
  'editing-track-info2': 'Add or remove articles, change the name of the track, and so on!',
  'order': 'Order',
  'selected-article': 'Selected Article',
  'searched-article': 'Searched Article',
  'track-name-placeholder': 'i.e. General knowledge',
  'track-description-placeholder': 'Try to describe the purpose of this track',
  'choose-articles-for-the-track': 'Choose articles for the track',
  'chosen-articles': 'Chosen articles',
  'set-the-reading-order-of-articles': 'Set the reading order of articles',
  'created-by': 'Created by',
  'next-track-article': 'Next track article',
  'track-end': 'End of track!',

  // VIEW|ADD|EDIT USER
  'your-profile': '(Your profile)',
  'total-articles': 'Total articles:',
  'total-questions': 'Total questions:',
  'joined': 'Joined',
  'not-specified': '(not specified)',
  'user-articles': 'User\'s articles',
  'user-has-no-articles': '( this user has no articles )',
  'editing-user': 'Editing:',
  'permission': 'Permission',
  'reader': 'Reader',
  'writer': 'Writer',
  'super-user': 'Super User',
  'admin': 'Admin',
  'ceo': 'CEO',
  'import-users': 'Import users',
  'download-csv-model': 'Download the CSV model file',
  'here': 'here',
  'import': 'Import',
  'best-writer': 'Best Writer',
  'top-writer': 'Top Writer',
  'top-reader': 'Top Reader',
  'user-first-name-placeholder': 'i.e. Robson',
  'user-last-name-placeholder': 'i.e. da Silva',
  'user-email-placeholder': 'i.e. robson@email.com',
  'user-position-placeholder': 'i.e. Marketing Manager',
  'user-zip-code-placeholder': 'i.e. 66777',
  'user-state-placeholder': 'i.e. Ontário',
  'user-country-placeholder': 'i.e. Canada',
  'user-bio-placeholder': 'Try to describe yourself...',
  'the-chosen-department-will-be-associated-to': 'The chosen department will be associated to',
  'all-imported-users': 'all imported users',
  'my-articles': 'My articles',
  'my-questions': 'My questions',
  'my-tracks': 'My tracks',
  'users-articles': 'User\'s articles',
  'users-questions': 'User\'s questions',
  'users-tracks': 'User\'s tracks',
  'no-followed-users': 'No followed users',
  'no-followed-tracks': 'No followed tracks',
  'followed-users': 'Followed users',
  'followed-tracks': 'Followed tracks',

  // VIEW|ADD|EDIT ARTICLE
  'how-to-write-good-article': 'How to write a good article',
  'first-tip': 'Create a complete and explanatory title',
  'second-tip': 'Start with a summary, a brief introduction',
  'third-tip': 'Be clear and succinctly write down your ideas',
  'fourth-tip': 'Add images along the text',
  'fifth-tip': 'Use an appropriate format and language',
  'sixth-tip': 'Position keywords strategically',
  'save-and-publish': 'Save and Publish',
  'this-will-be-a-public-article': 'This will be a public article!',
  'this-will-be-a-department-only-article': 'This will be a department only article!',
  'article-tags-info1': 'Use "#" to insert tags in the text.',
  'article-tags-info2': 'This will make the search for your article easier.',
  'rate-this-article': 'Rate this article',
  'enter-title-here': 'Enter title here...',

  // MY-SPACE
  'write-article': 'Write an article',
  'last-update': 'Last update',
  'add-user': 'Add user(s)',
  'add-track': 'New track',
  'add-question': 'New question',
  'answered': 'Answered',
  'add-department': 'New department',

  // SETTINGS
  'settings-text': 'This is the page where you can edit your information and your preferences.',
  'settings': 'Settings',
  'preferences': 'Preferences',
  'change-profile-image': 'Change profile image',
  'first-name': 'First name',
  'last-name': 'Last name',
  'email': 'E-mail',
  'phone': 'Phone',
  'city': 'City',
  'zip-code': 'ZIP code',
  'state': 'State/Province',
  'country': 'Country',
  'birthday': 'Birthday',
  'position': 'Position',
  'gender': 'Gender',
  'biography': 'Biography',
  'male': 'Male',
  'female': 'Female',
  'other': 'Not specified',
  'language': 'Language',
  'change-password': 'Change password',
  'confirm-password': 'Confirm password',
  'drop-file-here-or': 'Drop file here or',
  'click-to-upload': 'click to upload',
  'jpg-png-files-with-size-less-than-500kb': 'jpg/png files with a size less than 500kb',

  // PREFERENCES
  'articles-notifications': 'Article\'s notifications:',
  'new-articles-from-followed-users': 'New articles from followed users',
  'new-articles': 'New articles',
  'updated-articles': 'Updated articles',
  'questions-notifications': 'Question\'s notifications:',
  'new-questions-from-followed-users': 'New questions from followed users',
  'new-questions': 'New questions',
  'answers-notifications': 'Answer\'s notifications:',
  'new-answers': 'New answers',
  'tracks-notifications': 'Track\'s notifications:',
  'new-tracks': 'New tracks',
  'updated-tracks': 'Updated tracks',
  'followed-tracks-updated': 'Followed tracks updated',
  'tags-notifications': 'Tag\'s notifications:',
  'new-or-updated-articles-with-followed-tags': 'New or updated articles with followed tags',
  'new-questions-with-followed-tags': 'New questions with followed tags',
  'email-notifications': 'E-mail notifications:',
  'receive-flagged-notifications-by-email': 'Receive flagged notifications by e-mail',
  'receive-featured-articles-by-email': 'Receive featured articles by e-mail',
  'receive-featured-questions-by-email': 'Receive featured questions by e-mail',

  // HOME
  'featured-users': 'Featured users',
  'empty-featured-users': 'here will appear the featured users',
  'you': 'you',
  'you-caps': 'You',
  'empty-trending-tags': 'here will appear the most used tags',
  'empty-followed-tags': 'you don\'t follow any tags',
  'latest-articles': 'Latest articles',
  'latest-tracks': 'Latest tracks',
  'latest-questions': 'Latest questions',

  // TABLES / RANKING PAGE / ANALYTICS
  'avatar': 'Picture',
  'user-name': 'Name',
  'total-rating': 'Total Rating',
  'created-articles': 'Created Articles',
  'created_articles': 'Created Articles',
  'readed-articles': 'Readed Articles',
  'readed_articles': 'Readed Articles',
  'new-followers': 'New Followers',
  'current-podium': 'Current Podium',
  'referring-to': 'Referring to',
  'ranking-page-description-1': 'Use this page to keep track of the Current Podium, the current Ranking as well as the Custom Period Ranking.',
  'ranking-page-description-2': 'Use the month/year selection box above the Ranking table to filter the results.',
  'best-writer-description': 'Top rated articles of the month.',
  'top-writer-description': 'Larger number of writed articles in the month.',
  'top-reader-description': 'Larger number of readed articles in the month.',
  'to': 'To:',
  'from': 'From:',
  'user-ranking': 'User Ranking',
  'begin-date': 'Data inicial',
  'end-date': 'Data final',
  'there-is-no-best-writer-yet': 'There\'s no Best Writer yet.',
  'there-is-no-top-writer-yet': 'There\'s no Top Writer yet.',
  'there-is-no-top-reader-yet': 'There\'s no Top Reader yet.',
  'download-csv': 'Download CSV',
  'analytics': 'Analytics',
  'analytics-description-page': 'This is the page where you can see all the company\'s analytics.',
  'answered-questions': 'Answered Questions',
  'top-tags': 'Top tags',
  'users-analytics': 'Users',
  'articles-analytics': 'Articles',
  'questions-analytics': 'Questions',
  'tracks-analytics': 'Tracks',
  'answered-plural': 'Answered(s)',
  'unanswered-plural': 'Unanswered(s)',
  'unanswered': 'Unanswered',
  'all-period': 'All period',
  'empty-users-table': 'No users for the selected filters',
  'empty-articles-table': 'No articles for the selected filters',
  'empty-questions-table': 'No questions for the selected filters',
  'empty-tracks-table': 'No tracks for the selected filters',
  'all-departments': 'All Departments',
  'filter-tables': 'Filter tables',
  'analytics-filter-description': 'You can filter tables by company\'s departments and/or by period.',
  'no-questions-to-process': 'There are no questions to process',
  'no-tags-to-process': 'There are no tags to process',

  // CSV Download
  'articles-label': 'NUMBER OF ARTICLES',
  'questions-label': 'NUMBER OF QUESTIONS',
  'tracks-label': 'NUMBER OF TRACKS',
  'answered-questions-label': 'NUMBER OF ANSWERED QUESTIONS',
  'unanswered-questions-label': 'NUMBER OF UNANSWERED QUESTIONS',
  'top-tags-label': 'TOP TAGS',
  'users-table-label': 'USERS',
  'articles-table-label': 'ARTICLES',
  'questions-table-label': 'QUESTIONS',
  'tracks-table-label': 'TRACKS',
  'tag-label': 'Tag',
  'tag-amount-label': 'Amount of use',
  'data-period-label': 'Data below refer to the period',
  'to-period': 'to',

  // DATABASE TRANSLATIONS
  'total_rating': 'Total Rating',
  'readings': 'Readings',
  'visits': 'Visits',
  'status': 'Status',
  'created_at': 'Created at',
  'total_answers': 'Answers',
  'anonymous': 'Anonymous',

  // CALENDAR
  'january': 'January',
  'february': 'February',
  'march': 'March',
  'april': 'April',
  'may': 'May',
  'june': 'June',
  'july': 'July',
  'august': 'August',
  'september': 'September',
  'october': 'October',
  'november': 'November',
  'december': 'December',

  // COUNTRIES
  'united-states': 'United States',
  'canada': 'Canada',
  'brazil': 'Brazil',
};
